'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Logo531 } from '@/components/ui/Logo531';
import { ThemeToggle } from '@/components/layout/ThemeToggle';

export default function NotFound() {
	const router = useRouter();
	const [countdown, setCountdown] = useState(10);

	useEffect(() => {
		const timer = setInterval(() => {
			setCountdown((previous) => Math.max(0, previous - 1));
		}, 1000);

		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		if (countdown === 0) {
			router.replace('/');
		}
	}, [countdown, router]);

	return (
		<div className="app-canvas flex min-h-dvh flex-col">
			<header className="flex items-center justify-between px-5 py-4 sm:px-8">
				<Logo531 className="h-8" />
				<ThemeToggle />
			</header>
			<main className="flex flex-1 items-center justify-center px-4 pb-12">
				<section className="app-panel w-full max-w-lg rounded-[2rem] p-7 text-center sm:p-10">
					<p className="app-eyebrow">404 · Off course</p>
					<h1 className="mt-3 font-serif text-5xl font-medium tracking-[-0.045em] sm:text-6xl">Nothing here.</h1>
					<p className="mx-auto mt-4 max-w-sm leading-relaxed text-muted-foreground">
						This page isn’t part of your 5·3·1. We’ll take you back to today’s work in {countdown} second
						{countdown === 1 ? '' : 's'}.
					</p>

					<div className="mx-auto mt-7 h-1.5 max-w-xs overflow-hidden rounded-full bg-muted" aria-hidden="true">
						<div
							className="h-full rounded-full bg-primary transition-[width] duration-1000 ease-linear motion-reduce:transition-none"
							style={{ width: `${((10 - countdown) / 10) * 100}%` }}
						/>
					</div>

					<Button onClick={() => router.replace('/')} className="mt-8 rounded-full px-6">
						<ArrowLeft aria-hidden="true" />
						Back to coach
					</Button>
				</section>
			</main>
		</div>
	);
}
